import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';
import { useT } from '@/lib/i18n';

export function PageShell({
  children,
  headerTheme = 'midnight',
}: {
  children: React.ReactNode;
  headerTheme?: 'midnight' | 'ivory' | undefined;
}): React.JSX.Element {
  const t = useT();

  return (
    <div className="flex min-h-screen flex-col">
      <a href="#main" className="mv-skip-link rounded-md bg-action px-4 py-2 text-on-accent">
        {t('common.skipToContent')}
      </a>
      <Header theme={headerTheme} />
      <main id="main" className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash]);

  return null;
}
